export default __webpack_public_path__ + "static/media/text-format-remove.1bd758d0.svg";